


























import { Component, Vue, Inject, Ref } from 'vue-property-decorator';

import HeadquarterList from './HeadquarterList.vue';
import { CrudService } from '@/data/services/crud.service';
import { Headquarter } from '@/data/models/headquarter.model';
import HeadquarterFilter from './HeadquarterFilter.vue';
import { Search } from '@/data/models/search.model';

@Component({
	components: {
		HeadquarterList,
		HeadquarterFilter,
	},
})
export default class Headquarters extends Vue {
	@Inject('CrudService') crudService!: CrudService<Headquarter>;

	@Ref('list') list!: HeadquarterList;
	@Ref('filter') filter!: HeadquarterFilter;

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadHeadquarters();
	}

	deleteHeadquarter(item: Headquarter) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-headquarter-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Headquarter, 'headquarter', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadHeadquarters();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}	

}
